import { useNavigate } from 'react-router-dom';

import { useTableContext } from 'lib/context/TableContext/TableContext';

import Popover from 'components/shared/Popovers/Popover/Popover';

const TableActions = (props) => {
  const { setSelectedItem, setShowModal } = useTableContext();
  const navigate = useNavigate();

  const hasWizard = props?.data?.wizard != null;

  const actionOptions = [
    ...(hasWizard
      ? [
          {
            label: 'Continue setup',
            icon: 'arrow-right-mono',
            onClick: () => {
              navigate(`${props.data?.id}/onboarding`);
            }
          }
        ]
      : []),
    {
      label: 'Edit practice',
      icon: 'edit-3-mono',
      onClick: () => {
        setSelectedItem(props.data);
        setShowModal(true);
      }
    },
    {
      label: 'Visit profile',
      icon: 'eye-mono',
      onClick: () => {
        navigate(String(props.data?.id));
      }
    }
  ];

  return (
    <Popover
      className="flex h-full w-full items-center justify-center"
      position="left"
      isFixed
      icon="context-menu-horizontal"
      isBorder={false}
      options={actionOptions}
    />
  );
};

export default TableActions;
